interface Data {
    urlMarketplace: string;
    urlSuite: string;
    urlGpassAdmin: string;
    hasFitBankAccount: boolean;
    loaded: boolean;
}

class Service {
    private data: Data = {
        urlMarketplace: '' ,
        urlSuite: '',
        urlGpassAdmin: '',
        hasFitBankAccount: false,
        loaded: false,
    };

    get urlMarketplace() {
        return this.data.urlMarketplace;
    }

    setUrlMarketplace(urlMarketplace: string) {
        this.data.urlMarketplace = urlMarketplace;
    }

    clearUrlMarketplace() {
        this.data.urlMarketplace = '';
    }

    get urlGpassAdmin() {
        return this.data.urlGpassAdmin;
    }

    setUrlGpassAdmin(urlGpassAdmin: string) {
        this.data.urlGpassAdmin = urlGpassAdmin;
    }

    clearUrlGpassAdmin() {
        this.data.urlGpassAdmin = '';
    }

    get urlSuite() {
        return this.data.urlSuite;
    }

    setUrlSuite(urlSuite: string) {
        this.data.urlSuite = urlSuite;
    }

    clearUrlSuite() {
        this.data.urlSuite = '';
    }

    hasFitBankAccount() {
        return this.data.hasFitBankAccount;
    }

    sethasFitBankAccount(hasFitBankAccount: boolean) {
        this.data.hasFitBankAccount = hasFitBankAccount;
    }

    clearhasFitBankAccount() {
        this.data.hasFitBankAccount = false;
    }

    getLoaded() {
        return this.data.loaded;
    }

    setLoaded(loaded: boolean) {
        this.data.loaded = loaded;
    }
}

export const ApplicationConfigService = new Service();
